export default __webpack_public_path__ + "images/Moni-Sakor-Vessantara-jataka.webp";